@if (!isMobile) {
  <div class="d-flex flex-column justify-content-between">
    <div>
      <div class="container mobile-container container-space bg-white">
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <div class="col-12 Title-box d-flex flex-column align-items-start justify-content-start">
              <span>{{ 'Why' | translate }} {{ Config.domain.Title }}؟</span>
              <img class="mt-2 d-lg-block d-none"
                   src="/icons/line-categories.svg">
            </div>
            <div class="col-12 descriptions">
              <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(Config.branch.Details.Landing.SiteSlogan ?? '')"></p>
            </div>
            <div class="d-grid grid-menu">
              <div class="d-flex mb-4">
                <div class="box-img">
                  <img src="/icons/Border1.svg">
                </div>
                <div class="flex-grow-1 w-100">
                  <span>{{ Config.branch.Details.Landing.SiteSloganDetails.Slogan_1 }}</span>
                  <p>{{ Config.branch.Details.Landing.SiteSloganDetails.SloganDescription_1 }}</p>
                </div>
              </div>
              <div class="d-flex mb-4">
                <div class="box-img">
                  <img src="/icons/Border1.svg">
                </div>
                <div class="flex-grow-1 w-100">
                  <span>{{ Config.branch.Details.Landing.SiteSloganDetails.Slogan_2 }}</span>
                  <p>{{ Config.branch.Details.Landing.SiteSloganDetails.SloganDescription_2 }}</p>
                </div>
              </div>
              <div class="d-flex mb-4">
                <div class="box-img">
                  <img src="/icons/Border1.svg">
                </div>
                <div class="flex-grow-1 w-100">
                  <span>{{ Config.branch.Details.Landing.SiteSloganDetails.Slogan_3 }}</span>
                  <p>{{ Config.branch.Details.Landing.SiteSloganDetails.SloganDescription_3 }}</p>
                </div>
              </div>
              <div class="d-flex mb-4">
                <div class="box-img">
                  <img src="/icons/Border1.svg">
                </div>
                <div class="flex-grow-1 w-100">
                  <span>{{ Config.branch.Details.Landing.SiteSloganDetails.Slogan_4 }}</span>
                  <p>{{ Config.branch.Details.Landing.SiteSloganDetails.SloganDescription_4 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 p-0">
            <div class="d-grid grid-img justify-content-start">
              <div class="img-box">
                <img [src]="formatImage('xxx', Config.branch.Details.Landing.SiteSloganDetails.Image_1)">
              </div>
              <div class="img-box">
                <img [src]="formatImage('xxx', Config.branch.Details.Landing.SiteSloganDetails.Image_2)">
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (Config.branch?.Details?.Events && Config.branch?.Details.Events.length > 0) {
        <div class="container mobile-container container-space bg-white">
          <div class="col-12 Title-box d-flex flex-column align-items-start justify-content-start mt-5">
            <span>{{ 'SpecialEvents' | translate }}</span>
            <img class="mt-2 d-lg-block d-none"
                 src="/icons/line-categories.svg">
          </div>
          <div class="events-section">
            <div class="events-intro">
              <p>{{ 'EventsIntroText' | translate }}</p>
            </div>
            <div class="events-list">
              @for (event of Config.branch?.Details?.Events; track $index) {
                <div (click)="onEventClicked(event)"
                     class="event-item">
                  <div class="event-icon">
                    <img alt="Event"
                         src="/icons/event.png">
                  </div>
                  <div class="event-content">
                    <h3>{{ event.Title }}</h3>
                    <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(event.Description ?? '')"></p>
                  </div>
                  <div class="event-actions">
                    <button
                      class="event-btn">
                      {{ 'ViewPackage' | translate }}
                    </button>
                  </div>
                </div>
              }
            </div>
            <div class="events-contact">
              <button (click)="onSocialMedialClicked()"
                      class="contact-btn">
                <img alt="WhatsApp"
                     src="/icons/whatsapp.svg"
                     style="width: 20px; height: 20px; margin-left: 8px;">
                {{ 'ContactWhatsApp' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
      <div [ngStyle]="{'background-image': backgroundImage}"
           class="banner d-flex align-items-center">
        <div class="container p-5 h-100">
          <div class="row h-100">
            <div class="col-lg-6 col-12 h-100 d-flex flex-column
             align-items-lg-start align-items-center justify-content-center
              mb-lg-0 mb-3">
              <div class="welcome-box d-flex flex-column align-items-center justify-content-center">
                <span>{{ 'Welcome' | translate }}</span>
                <img class="mb-2"
                     src="/icons/line.svg">
              </div>
              <span class="banner-title">پذیرای شما هستیم</span>
              <app-frontend-button (click)="openHomeClicked()"
                                   [class]="'card-red'"
                                   [title]="'OrderOnline'"></app-frontend-button>
            </div>
            <div class="col-lg-6 col-12 d-flex align-items-center justify-content-center">
              <div class="date-box d-flex flex-column align-items-center justify-content-center">
                <div class=" d-flex flex-column align-items-center justify-content-center mb-3">
                  <span>{{ formatTimeSheetText(Config.branch.Details.Landing.ServiceTimeSheet.TimeSheetText ?? '') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mobile-container container-space bg-white">
        <div class="col-12 Title-box d-flex flex-column align-items-start justify-content-start mt-5">
          <div class="d-flex align-items-center gap-3">
            <span>{{ 'PhotoGallery' | translate }}</span>
            <span class="image-counter">({{ currentImageIndex + 1 }}/{{ totalImages }})</span>
          </div>
          <img class="mt-2 d-lg-block d-none"
               src="/icons/line-categories.svg">
        </div>
        <div class="col-12 gallery-container mb-5">
          <div class="gallery-wrapper d-flex gap-3">
            <div class="box1 gallery-box">
              <img [src]="getGalleryImage(0)"
                   alt="Gallery Image">
            </div>
            <div class="box2 gallery-box">
              <img [src]="getGalleryImage(1)"
                   alt="Gallery Image">
            </div>
            <div class="box3 gallery-box">
              <img [src]="getGalleryImage(2)"
                   alt="Gallery Image">
            </div>
            <div class="box4 gallery-box">
              <img [src]="getGalleryImage(3)"
                   alt="Gallery Image">
            </div>
            <div class="box1 gallery-box">
              <img [src]="getGalleryImage(4)"
                   alt="Gallery Image">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else if (isMobile) {
  <div class="container-fluid p-0">
    <div class="col-12 background-mobile">
      <video #videoElement
             *ngIf="randomVideoUrl"
             autoplay
             loop
             muted
             playsinline
             preload="metadata"
             webkit-playsinline>
        <source [src]="randomVideoUrl"
                type="video/mp4">
      </video>
      <div class="content-wrapper">
        <div class="position-relative top-0 start-0 h-100 w-100"
             style="z-index: 99; padding: 0px 32px 10px 32px;
    overflow-y: auto;">
          <div class="col-12 d-flex flex-column align-items-center justify-content-center logo-box-mobile">
            <img
              [ngStyle]="{ 'background': Config.domain?.Details?.LogoBackgroundColor || '','opacity': Config.domain?.Details?.LogoBackgroundOpacity || 1}"
              [src]="formatImage('', Config.branch.Details.LogoText)"
              style="width: 150px;height: 150px;padding: 8px">
          </div>
          <div class="box-btn w-100 d-flex flex-column align-items-center pb-3">
            <div class="row w-100">
              @if (!authenticationService.hasAccount()) {
                <div class="col-6">
                  <app-frontend-button (click)="openLogin()"
                                       [Image]="true"
                                       [class]="'card-light'"
                                       [src]="'/icons/login.svg'"
                                       [title]="'LoginOrRegister'"
                                       class="full-width-btn col-12"></app-frontend-button>
                </div>
                <div class="col-6 d-flex">
                  <app-frontend-button (click)="openHomeClicked()"
                                       [Image]="true"
                                       [class]="'card-red'"
                                       [src]="'/icons/menu-footer.svg'"
                                       [title]="'ShowMenu'"
                                       class="full-width-btn col-12"></app-frontend-button>
                </div>
                @for (event of Config.branch?.Details?.Events; track $index) {
                  <div class="col-12 d-flex mt-2">
                    <div (click)="onEventClicked(event)"
                         [class.no-description]="!event.Description"
                         class="event-card-mobile">
                      <div class="event-header">
                        <h4 class="event-title-mobile">
                          <img alt="Event"
                               class="event-icon-mobile"
                               src="/icons/event.png">
                          {{ event.Title }}
                        </h4>
                        <button class="event-action-btn-mobile">
                          {{ event.ButtonTitle }}
                        </button>
                      </div>
                      @if (event.Description) {
                        <div class="event-description-container">
                          <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(event.Description ?? '')"
                             class="event-description-mobile"></p>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (sortedSocialMedias && sortedSocialMedias.length > 0) {
                  <div class="col-12 d-flex mt-2">
                    <div class="social-media-grid">
                      @for (social of sortedSocialMedias; track $index) {
                        @if (social.Type === "WHATSAPP") {
                          <div (click)="onSocialMedialClicked(social)"
                               class="social-media-item social-whatsapp">
                            <img alt="WhatsApp"
                                 src="/icons/whatsapp.svg">
                            <span>{{ social.Title }}</span>
                          </div>
                        } @else if (social.Type === "TELEGRAM") {
                          <div (click)="onSocialMedialClicked(social)"
                               class="social-media-item social-telegram">
                            <img alt="Telegram"
                                 src="/icons/telegram.svg">
                            <span>{{ social.Title }}</span>
                          </div>
                        } @else if (social.Type === "INSTAGRAM") {
                          <div (click)="onSocialMedialClicked(social)"
                               class="social-media-item social-instagram">
                            <img alt="Instagram"
                                 src="/icons/instagram.svg">
                            <span>{{ social.Title }}</span>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              } @else {
                <div class="col-12 d-flex px-0 mb-3">
                  <app-frontend-button (click)="openHomeClicked()"
                                       [Image]="true"
                                       [class]="'card-red'"
                                       [src]="'/icons/menu-footer.svg'"
                                       [title]="'ShowMenu'"
                                       class="full-width-btn justify-content-center col-12"></app-frontend-button>
                </div>
                @for (event of Config.branch?.Details?.Events; track $index) {
                  <div class="col-12 d-flex mt-2">
                    <div (click)="onEventClicked(event)"
                         [class.no-description]="!event.Description"
                         class="event-card-mobile">
                      <div class="event-header">
                        <h4 class="event-title-mobile">
                          <img alt="Event"
                               class="event-icon-mobile"
                               src="/icons/event.png">
                          {{ event.Title }}
                        </h4>
                        <button class="event-action-btn-mobile">
                          {{ event.ButtonTitle }}
                        </button>
                      </div>
                      @if (event.Description) {
                        <div class="event-description-container">
                          <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(event.Description ?? '')"
                             class="event-description-mobile"></p>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (sortedSocialMedias && sortedSocialMedias.length > 0) {
                  <div class="col-12 d-flex mt-2">
                    <div class="social-media-grid">
                      @for (social of sortedSocialMedias; track $index) {
                        @if (social.Type === "WHATSAPP") {
                          <div (click)="onSocialMedialClicked(social)"
                               class="social-media-item social-whatsapp">
                            <img alt="WhatsApp"
                                 src="/icons/whatsapp.svg">
                            <span>{{ social.Title }}</span>
                          </div>
                        } @else if (social.Type === "TELEGRAM") {
                          <div (click)="onSocialMedialClicked(social)"
                               class="social-media-item social-telegram">
                            <img alt="Telegram"
                                 src="/icons/telegram.svg">
                            <span>{{ social.Title }}</span>
                          </div>
                        } @else if (social.Type === "INSTAGRAM") {
                          <div (click)="onSocialMedialClicked(social)"
                               class="social-media-item social-instagram">
                            <img alt="Instagram"
                                 src="/icons/instagram.svg">
                            <span>{{ social.Title }}</span>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
          @if (Config.branch && Config.branch.Details) {
            <div class="info-page">
              @if (Config.branch.Details?.Address) {
                <div class="col-12 mb-3">
                  <p>{{ 'Address' | translate }}</p>
                  <span>{{ Config.branch.Details?.Address }}</span>
                </div>
              }
              @if (Config.branch.Details?.Phone) {
                <div class="col-12 mb-3">
                  <p>{{ 'Phone' | translate }}</p>
                  <span (click)="makePhoneCall(Config.branch.Details?.Phone)"
                        [title]="'Click to call' | translate">
                  {{ Config.branch.Details?.Phone }}
                </span>
                </div>
              }
              @if (Config.branch.Details?.Landing?.ServiceTimeSheet?.TimeSheetText) {
                <div class="col-12">
                  <p>{{ 'WorkingHours' | translate }}</p>
                  <span>{{ formatTimeSheetText(Config.branch.Details?.Landing?.ServiceTimeSheet?.TimeSheetText ?? '') }}</span>
                </div>
              }
              @if (Config.branch.Details?.AddressLatitude && Config.branch.Details?.AddressLongitude) {
                <div class="col-12 box-map"
                     style="padding: 5px">
                  <app-frontend-map [(latitudePointer)]="Config.branch.Details.AddressLatitude"
                                    [(longitudePointer)]="Config.branch.Details.AddressLongitude"
                                    [addressTitle]="Config.branch?.Details?.Address"
                                    [height]="'90px'"
                                    [isClickable]="true"
                                    [openMapOnClick]="true"
                                    [width]="'100%'"></app-frontend-map>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
